import React, {useState} from 'react'
import {toAbsoluteUrl} from '../../../../../template/_metronic/helpers'
import SVG from 'react-inlinesvg'

type Props = {
  className: string
}

export const InputPassword = ({className, ...props}: Props) => {
  const [showPassword, setShowPassword] = useState(true)

  const handleClick = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className='input-group'>
      <input
        placeholder='Contraseña'
        type={showPassword ? 'password' : 'text'}
        autoComplete='off'
				{...props}
        className={`form-control form-control-lg form-control-solid text-primary-dark border-0 fs-3 ${className}`}
      />

      <span className='input-group-text border-0' onClick={handleClick}>
        <SVG
          src={
            showPassword
              ? toAbsoluteUrl('/media/soyfri-media/eye.svg')
              : toAbsoluteUrl('/media/soyfri-media/eye-crossed.svg')
          }
        />
      </span>
    </div>
  )
}
